import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 公共路由
export const constantRoutes = [
  {
    path: '/login',
    component: (resolve) => require(['../views/login'], resolve)
  },
  {
    path: '',
    component: (resolve) => require(['../components/layout'], resolve),
    redirect: '/login',
    children: [
      {
        path: 'index',
        component: (resolve) => require(['../views/index'], resolve),
      },
	  {
	    path: 'work',
	    component: (resolve) => require(['../views/work/work'], resolve),
	  },
	  {
	    path: 'workManage',
	    component: (resolve) => require(['../views/work/workManage'], resolve),
	  },
	  {
	    path: 'score',
	    component: (resolve) => require(['../views/work/score'], resolve),
	  },
	  {
	    path: 'userInfo',
	    component: (resolve) => require(['../views/work/userInfo'], resolve),
	  },
	  {
	    path: 'set',
	    component: (resolve) => require(['../views/work/set'], resolve),
	  },
	  {
	    path: 'exchangeDetail',
	    component: (resolve) => require(['../views/work/exchangeDetail'], resolve),
	  },
	  {
	    path: 'addAc',
	    component: (resolve) => require(['../views/work/addAc'], resolve),
	  },
	  {
	    path: 'videoCheck',
	    component: (resolve) => require(['../views/work/videoCheck'], resolve),
	  },
	  {
	    path: 'videoCheckRecord',
	    component: (resolve) => require(['../views/work/videoCheckRecord'], resolve),
	  },
		{
		  path: 'supervise',
		  component: (resolve) => require(['../views/supervise/supervise'], resolve),
		},
		{
		  path: 'category',
		  component: (resolve) => require(['../views/classify/category'], resolve),
		},
	  {
	    path: 'question',
	    component: (resolve) => require(['../views/summary/question'], resolve),
	  },
	  {
	    path: 'subject',
	    component: (resolve) => require(['../views/summary/subject'], resolve),
	  },
	  {
	    path: 'result',
	    component: (resolve) => require(['../views/summary/result'], resolve),
	  },
	  {
	    path: 'imgList',
	    component: (resolve) => require(['../views/summary/imgList'], resolve),
	  },
		{
		  path: 'patrol',
		  component: (resolve) => require(['../views/summary/patrol'], resolve),
		},
		{
		  path: 'map',
		  component: (resolve) => require(['../views/summary/map'], resolve),
		},
	  {
	    path: 'clock',
	    component: (resolve) => require(['../views/summary/clock'], resolve),
	  },
	  {
	    path: 'vehicleLockLog',
	    component: (resolve) => require(['../views/vehicle/vehicleLockLog'], resolve),
	  },
	  {
	    path: 'dictItem',
	    component: (resolve) => require(['../views/sys/dictItem'], resolve),
	  },
	  {
	    path: 'performance',
	    component: (resolve) => require(['../views/summary/performance'], resolve),
	  },
	  {
	    path: 'performance2',
	    component: (resolve) => require(['../views/summary/performance2'], resolve),
	  },
	  {
	    path: 'user',
	    component: (resolve) => require(['../views/sys/user'], resolve),
	  },
	  {
	    path: 'role',
	    component: (resolve) => require(['../views/sys/role'], resolve),
	  },
	  {
	    path: 'caseCheck',
	    component: (resolve) => require(['../views/case/caseCheck'], resolve),
	  },
    ]
  }
]

export default new Router({
  // mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
